import client from './client';

export async function listBulkRequestCandidates(params) {
  const { data } = await client.get('/bulk-requests/candidates', { params });
  return data.data;
}

export async function createBulkRequest(payload) {
  const { data } = await client.post('/bulk-requests', payload);
  return data.data;
}

export async function listBulkRequests(params) {
  const { data } = await client.get('/bulk-requests', { params });
  return data.data;
}

export async function bulkRequestCount() {
  const { data } = await client.get('/bulk-requests/count');
  return data.data.count;
}

export async function approveBulkRequest(id) {
  const { data } = await client.post(`/bulk-requests/${id}/approve`);
  return data.data;
}

export async function rejectBulkRequest(id, review_remarks) {
  const { data } = await client.post(`/bulk-requests/${id}/reject`, { review_remarks });
  return data.data;
}
